import { maintenance_outage_order_maker, field_maker } from "helper";
import { alias_maker, select_options_maker } from "helper";

export const MAINTENANCE_FIELD_ENUM = {
    maintenance_starttime: "maintenance_starttime",
    maintenance_endtime: "maintenance_endtime",
    comments: "comments",
    url_affected: "url_affected",
    tenant: "tenant"
};

const maintenance_fields = {
    ...field_maker("id", "-", "string"),
    ...field_maker(MAINTENANCE_FIELD_ENUM.maintenance_starttime, "Start Time (UTC)", "dateTime"),
    ...field_maker(MAINTENANCE_FIELD_ENUM.maintenance_endtime, "End Time (UTC)", "dateTime"),
    ...field_maker(MAINTENANCE_FIELD_ENUM.comments, "Comments", "string"),
    ...field_maker(MAINTENANCE_FIELD_ENUM.url_affected, "URLs Affected", "string"),
    ...field_maker(MAINTENANCE_FIELD_ENUM.tenant, "Tenant", "string"),
    ...field_maker("__mark__", "Mark for Delete", "string"),
};

const MAINTENANCE_ORDER = [
    maintenance_outage_order_maker(
        maintenance_fields[MAINTENANCE_FIELD_ENUM.maintenance_starttime],
        200
    ),
    maintenance_outage_order_maker(
        maintenance_fields[MAINTENANCE_FIELD_ENUM.maintenance_endtime],
        200
    ),
    maintenance_outage_order_maker(maintenance_fields[MAINTENANCE_FIELD_ENUM.comments], 400),
    maintenance_outage_order_maker(maintenance_fields[MAINTENANCE_FIELD_ENUM.url_affected], 400),
    maintenance_outage_order_maker(maintenance_fields[MAINTENANCE_FIELD_ENUM.tenant], 400),
];

export const NCE_URLS = [
    alias_maker("https://api.1nce.com/management-api/v1/products", "1NCE-API-Products"),
    alias_maker("https://api.1nce.com/management-api/v1/sims", "1NCE-API-Sims"),
    alias_maker("https://portal.1nce.com/portal/customer/connectivitysuite", "1NCE-OS"),
    alias_maker("https://portal.1nce.com", "1NCE-Portal-Content"),
    alias_maker("https://portal.1nce.com/en/portal/customer/login", "1NCE-Portal-Login"),
    alias_maker("https://shop.1nce.com/de", "1NCE-Shop-Content-DE"),
    alias_maker("https://shop.1nce.com/portal/shop", "1NCE-Shop-Content"),
    // alias_maker("https://shop.1nce.com/en", "1NCE-Shop-Content"),
    alias_maker("https://1nce.com", "1NCE-Website-Content"),
    alias_maker("https://wyj52gwde9.execute-api.eu-central-1.amazonaws.com/webprobes/list-clients", "BSS-AAX-API"),
    alias_maker("emnify-data-streamer", "Emnify-Data-Streamer"),
];

export const BONG_URLS = [
    alias_maker("https://api.1nce.com/management-api/v2/sims", "REST API (https://api.1nce.com/management-api/v2/sims)"),
    alias_maker("https://portal.1nce.com/en/portal/customer/login", "Portal login (https://portal.1nce.com/en/portal/customer/login)"),
    alias_maker("oss-data-streamer", "OSS-Data-Streamer"),
];


// Correct URLs for Bell CMP will be provided later
export const BELL_URLS = [
    alias_maker("https://api.1nce.com/management-api/v2/sims", "REST API (https://api.1nce.com/management-api/v2/sims)"),
    alias_maker("https://portal.1nce.com/en/portal/customer/login", "Portal login (https://portal.1nce.com/en/portal/customer/login)"),
    alias_maker("oss-data-streamer", "OSS-Data-Streamer"),
];

export const DTAG_TMNL_URLS = [
    alias_maker(
        "https://api-easyconnect.iot.t-mobile.nl/management-api/v1/products",
        "TMNL-API-Products"
    ),
    alias_maker(
        "https://api-easyconnect.iot.t-mobile.nl/management-api/v1/sims",
        "TMNL-API-Sims"
    ),
    alias_maker("https://easyconnect.iot.t-mobile.nl/tmnl-portal/login", "TMNL-Portal-Login"),
];

export const DTIOT_WEB_PROBE_URLS = [
    alias_maker("https://concloud.iot.telekom.com", "Service Portal Availability"),
    alias_maker("https://api.concloud.iot.telekom.com/api/v1/endpoint?page=1&per_page=20", "API Availability"),
];

export const PROBE_SERVICES = {
    "1NCE": NCE_URLS,
    "DTAG/TMNL": DTAG_TMNL_URLS,
    "1nce_connect_cmp": BONG_URLS,
    "1nce_connect_legacy": NCE_URLS,
    "bell_cmp": BELL_URLS,
};

export const DTIOT_WEB_PROBE_SERVICES = {
    "DT-IoT": DTIOT_WEB_PROBE_URLS,
};

export const NETWORK_PROBE_SERVICES = [
    alias_maker("GPRS (2G/3G)"),
    alias_maker("LTE/NB-IoT (4G)"),
    alias_maker("SMS-MO"),
    alias_maker("SMS-MT"),
    alias_maker("Open VPN"),
];

export const BELL_NETWORK_PROBE_SERVICES = [
    alias_maker("GPRS (2G/3G)"),
    alias_maker("LTE/NB-IoT (4G)"),
    alias_maker("NR (5G)"),
    alias_maker("SMS-MO"),
    alias_maker("SMS-MT"),
    alias_maker("Open VPN"),
];

export const NETWORK_PROBE_SERVICES_TENANT_MAP = {
    "1NCE": NETWORK_PROBE_SERVICES,
    "1nce_connect_cmp": NETWORK_PROBE_SERVICES,
    "1nce_connect_legacy": NETWORK_PROBE_SERVICES,
    "bell_cmp": BELL_NETWORK_PROBE_SERVICES,
};

export const NGP_NETWORK_PROBE_SERVICES = [
    alias_maker("2G"),
    alias_maker("4G"),
    alias_maker("NB-IoT"),
    alias_maker("SMS-MO"),
    alias_maker("SMS-MT"),
];

export const PROBE_SERVICES_OPTIONS = select_options_maker(Object.keys(PROBE_SERVICES));
export const DTIOT_WEB_PROBE_SERVICES_OPTIONS = select_options_maker(Object.keys(DTIOT_WEB_PROBE_SERVICES));

    // webprobe_kpi_mnt_conf -> web_probe
    // network_probes_1nce_mnt_conf -> network_probe
export const PROBE_OPTIONS = [
    alias_maker("web_probe", "Web"),
    alias_maker("network_probe", "Network"),
    // alias_maker("network_probes_tmnl_mnt_conf", "TMNL Network"),
    // alias_maker("network_probes_dtag_mnt_conf", "DTAG Network"),
];

export const TENANT_OPTIONS_MAP = {
    "1nce_connect_cmp": "1NCE Connect (CMP)",
    "1nce_connect_legacy": "1NCE Connect (Legacy)",
    "bell_cmp": "Bell (CMP)",
};

export const TENANT_OPTIONS = [
    alias_maker("1nce_connect_cmp", "1NCE Connect (CMP)"),
    alias_maker("1nce_connect_legacy", "1NCE Connect (Legacy)"),
    alias_maker("bell_cmp", "Bell (CMP)"),
    // alias_maker("NGP DT-IoT", "NGP DT-IoT"),
];

export default MAINTENANCE_ORDER;
